import { render, staticRenderFns } from "./Recaudacionv8.vue?vue&type=template&id=bb58378a"
import script from "./Recaudacionv8.vue?vue&type=script&lang=js"
export * from "./Recaudacionv8.vue?vue&type=script&lang=js"
import style0 from "./Recaudacionv8.vue?vue&type=style&index=0&id=bb58378a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports